import { useRedline } from '@services/redline';
import constantsRedline from '@services/redline/constants';

import { ElementEventPayload } from './types';

export const useTracking = () => {
  const { track: trackRedline, getCorrelationId } = useRedline();

  function getRedlineCorrelationId() {
    return getCorrelationId(constantsRedline.RL_TRACK_CID);
  }

  function elementClickedEvent(eventPayload: ElementEventPayload) {
    const payload = {
      webElement: {
        ...eventPayload,
      },
    };

    trackRedline.userTracking.elementClicked(payload);
  }

  function elementViewedEvent(eventPayload?: ElementEventPayload) {
    const payload = { webElement: { ...eventPayload } };

    trackRedline.userTracking.elementViewed(payload);
  }

  return {
    elementClickedEvent,
    elementViewedEvent,
  };
};
